import { LEGACY_ACCOUNT_IDS, NEW_ONBOARDING_WORKFLOW } from '@/constants/constants';

export const maxTwoDecimalPlaces = (num: number) => {
  const decimalCount = num.toString()?.split('.')?.[1]?.length;
  let value = Number(num);
  if (decimalCount > 2) {
    value = Number(num.toFixed(2));
  }
  return value;
};

export function isValidEmail(email: string) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const isHebrew = (string: string) => {
  return !!string?.split('').some((x) => x.match(/[\u0590-\u05FF]/));
};

export const isNewOnboardingFlow = (workflow: string | undefined, accountId?: number) => {
  const isWorkFlowNew = !workflow || workflow === NEW_ONBOARDING_WORKFLOW;

  if (!accountId) return isWorkFlowNew;

  if (LEGACY_ACCOUNT_IDS.includes(accountId)) return false;

  return isWorkFlowNew;
};

export type Platform = 'mobile' | 'electron' | 'browser';

export const isElectron = (): boolean => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.includes('electron')) {
    return true;
  }

  if (typeof window !== 'undefined') {
    if ('require' in window) {
      return true;
    }

    if ('electronAPI' in window) {
      return true;
    }
  }

  try {
    if (
      typeof process !== 'undefined' &&
      process.versions &&
      process.versions.electron
    ) {
      return true;
    }
  } catch {
    // process might not be available
  }

  return false;
};

export const getPlatform = (mondayMode?: string): Platform => {
  if (mondayMode === 'mobile') {
    return 'mobile';
  }

  if (isElectron()) {
    return 'electron';
  }

  return 'browser';
};
